import { render, staticRenderFns } from "./head.vue?vue&type=template&id=9ef2c52e&scoped=true&"
import script from "./head.js?vue&type=script&lang=js&"
export * from "./head.js?vue&type=script&lang=js&"
import style0 from "../../index.scss?vue&type=style&index=0&id=9ef2c52e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef2c52e",
  null
  
)

export default component.exports